<template>
  <v-text-field
    @change="$emit('attrUpdate', $event)"
    :value="initialName"
    :rules="[(v) => !!v || $t('field-requied')]"
    :label="$t('experiment-name')"
    :prepend-inner-icon="mdiFileOutline"
    name="name"
    class="body-2"
    placeholder=" "
    outlined
    validate-on-blur
    required
  />
</template>

<script>
import { mdiFileOutline } from "@mdi/js";
export default {
  name: "FeildSimple",
  props: { initialName: String },
  data: () => ({ mdiFileOutline }),
};
</script>
